import { render } from "./AmbulanceManagement.vue?vue&type=template&id=5c4cb280&scoped=true"
import script from "./AmbulanceManagement.vue?vue&type=script&lang=js"
export * from "./AmbulanceManagement.vue?vue&type=script&lang=js"

import "./AmbulanceManagement.vue?vue&type=style&index=0&id=5c4cb280&lang=css"
import "./AmbulanceManagement.vue?vue&type=style&index=1&id=5c4cb280&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4cb280"]])

export default __exports__